module.exports = __webpack_public_path__ + "img/sololearnHTML.982eebcd.webp";